module.exports = __webpack_public_path__ + "img/face-smile-plus.b4f0e991.svg";